export const SET_ROOM_ACTION_TYPE = 'SET_ROOM_ACTION_TYPE' as const;

export const ADD_ROOM_ACTION_TYPE = 'ADD_ROOM_ACTION_TYPE' as const;

export const DELETE_ROOM_ACTION_TYPE = 'DELETE_ROOM_ACTION_TYPE' as const;

export const UPDATE_ROOM_ACTION_TYPE = 'UPDATE_ROOM_ACTION_TYPE' as const;
